import { render, staticRenderFns } from "./DepositRejectedModal.vue?vue&type=template&id=56cccee4&"
import script from "./DepositRejectedModal.vue?vue&type=script&lang=js&"
export * from "./DepositRejectedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports